import React from 'react';
import './APIEndpointCard.css';

function APIEndpointCard({ 
  endpoint, 
  index, 
  totalEndpoints,
  onUpdate, 
  onRemove 
}) {
  const methods = ['GET', 'POST', 'PUT', 'DELETE', 'PATCH'];

  const handleChange = (field, value) => {
    onUpdate(index, { ...endpoint, [field]: value });
  };

  return (
    <div className="api-endpoint-card">
      <div className="card-header">
        <span className="endpoint-number">Endpoint {index + 1}/{totalEndpoints}</span>
        <button
          className="btn-remove-endpoint"
          onClick={() => onRemove(index)}
          disabled={totalEndpoints === 1}
          title={totalEndpoints === 1 ? 'At least one endpoint required' : 'Remove endpoint'}
        >
          ✕
        </button>
      </div>

      <div className="card-body">
        {/* Method and URL */}
        <div className="endpoint-row">
          <div className="endpoint-field method-field">
            <label>Method</label>
            <select
              value={endpoint.method}
              onChange={(e) => handleChange('method', e.target.value)}
              className="endpoint-select"
            >
              {methods.map(method => (
                <option key={method} value={method}>{method}</option>
              ))}
            </select>
          </div>
          <div className="endpoint-field url-field">
            <label>URL</label>
            <input
              type="text"
              value={endpoint.url}
              onChange={(e) => handleChange('url', e.target.value)}
              placeholder="https://api.example.com/v1/resource"
              className="endpoint-input"
            />
          </div>
        </div>

        {/* Authorization */}
        <div className="endpoint-field">
          <label>Authorization</label>
          <input
            type="text"
            value={endpoint.auth}
            onChange={(e) => handleChange('auth', e.target.value)}
            placeholder="Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
            className="endpoint-input"
          />
        </div>

        {/* Headers */}
        <div className="endpoint-field">
          <label>Headers</label>
          <textarea
            value={endpoint.headers}
            onChange={(e) => handleChange('headers', e.target.value)}
            placeholder={'Content-Type: application/json\nAccept: application/json\nX-Custom-Header: value'}
            className="endpoint-textarea"
            rows={3}
          />
        </div>

        {/* Request Body */}
        <div className="endpoint-field">
          <label>Request Body</label>
          <textarea
            value={endpoint.body}
            onChange={(e) => handleChange('body', e.target.value)}
            placeholder={'{\n  "key": "value",\n  "items": []\n}'}
            className="endpoint-textarea code-textarea"
            rows={5}
          />
        </div>

        {/* Expected Response */}
        <div className="endpoint-field">
          <label>Expected Response</label>
          <textarea
            value={endpoint.expectedResponse}
            onChange={(e) => handleChange('expectedResponse', e.target.value)}
            placeholder={'{\n  "id": "123",\n  "status": "success"\n}'}
            className="endpoint-textarea code-textarea"
            rows={5}
          />
        </div>

        {/* Description */}
        <div className="endpoint-field">
          <label>Description / Requirements</label>
          <textarea
            value={endpoint.description}
            onChange={(e) => handleChange('description', e.target.value)}
            placeholder="Describe what this endpoint should do, validation rules, business logic, etc."
            className="endpoint-textarea"
            rows={3}
          />
        </div>
      </div>
    </div>
  );
}

export default APIEndpointCard;
